var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeDeliveryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3C1.4375 3 1 3.46875 1 4V13C1 13.5625 1.4375 14 2 14H2.15625C2.5625 12.8438 3.6875 12 5 12C6.28125 12 7.40625 12.8438 7.8125 14H12V4C12 3.46875 11.5312 3 11 3H2ZM2 15C0.875 15 0 14.125 0 13V4C0 2.90625 0.875 2 2 2H11C12.0938 2 13 2.90625 13 4V5H15.0312C15.4688 5 15.875 5.21875 16.1562 5.53125L18.625 8.40625C18.8438 8.6875 19 9.03125 19 9.375V14H19.5C19.75 14 20 14.25 20 14.5C20 14.7812 19.75 15 19.5 15H18C18 16.6562 16.6562 18 15 18C13.3438 18 12 16.6562 12 15H8C8 16.6562 6.65625 18 5 18C3.34375 18 2 16.6562 2 15ZM13 9H17.8125L15.4062 6.1875C15.3125 6.09375 15.1562 6 15.0312 6H13V9ZM13 10V12.7812C13.5312 12.3125 14.2188 12 15 12C16.2812 12 17.4062 12.8438 17.8125 14H18V10H13ZM7 15C7 14.3125 6.59375 13.6562 6 13.2812C5.375 12.9375 4.59375 12.9375 4 13.2812C3.375 13.6562 3 14.3125 3 15C3 15.7188 3.375 16.375 4 16.75C4.59375 17.0938 5.375 17.0938 6 16.75C6.59375 16.375 7 15.7188 7 15ZM15 17C15.6875 17 16.3438 16.625 16.7188 16C17.0625 15.4062 17.0625 14.625 16.7188 14C16.3438 13.4062 15.6875 13 15 13C14.2812 13 13.625 13.4062 13.25 14C12.9062 14.625 12.9062 15.4062 13.25 16C13.625 16.625 14.2812 17 15 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDeliveryWhite);
export default __webpack_public_path__ + "static/media/free-delivery-white.076492a5b6e295ee7c7d58afcfe8b98b.svg";
export { ForwardRef as ReactComponent };